/* eslint-disable no-empty */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import _ from 'underscore';
import $ from 'jquery';
import config from '@bingads-webui-clientcenter/config';

const compactFrameworkScriptUrl = _.get(window._webpack_app_props, ['baseUrls', 'CompactFrameworkScript']);

const answerBarLoader = function () {
  const asyncScriptLoad = function (source, onLoad) {
    const ajaxOption = {
      dataType: 'script',
      cache: true,
      url: source,
    };
    $.ajax(ajaxOption).error(() => {}).success(() => {
      if (typeof onLoad === 'function') {
        try {
          onLoad();
        } catch (e) {
        } // non mandatory call, if something goes wrong host should not be affected.
      }
    });
  };

  asyncScriptLoad(compactFrameworkScriptUrl, () => {
    if (typeof $.fn.InitApexPlatform === 'function') {
      const supportConfigs = config.get('SupportOptions') || {};
      const currentAccount = config.get('CurrentAccount') || {};
      const currentCustomer = config.get('CurrentCustomer') || {};
      const currentUser = config.get('CurrentUser') || {};
      $.fn.InitApexPlatform({
        Project: 'bing_ads',
        SupportOptions: {
          AccountNumber: currentAccount.AccountNumber,
          AccountName: currentAccount.ShortName,
          CustomerId: currentCustomer.Id,
          CustomerName: currentCustomer.Name,
          UserName: currentUser.Name,
          UserEmail: currentUser.Email,
          ShowLivePerson: supportConfigs.IfShowLiveChat,
          LivePersonSection: supportConfigs.LiveChatSection,
          PhoneLabel: supportConfigs.PhoneSupportLabel,
          Phone: supportConfigs.IfShowPhoneSupport ? supportConfigs.PhoneSupportNumber : null,
          PhoneInterval: supportConfigs.PhoneSupportSchedule && supportConfigs.PhoneSupportSchedule.Interval,
          PhoneTimeZone: supportConfigs.PhoneSupportSchedule && supportConfigs.PhoneSupportSchedule.TimeZone,
          EmailLabel: supportConfigs.EmailSupportEmail,
          Email: supportConfigs.EmailSupportEmail,
          EmailInterval: supportConfigs.EmailSupportSchedule && supportConfigs.EmailSupportSchedule.Interval,
          EmailTimeZone: supportConfigs.EmailSupportSchedule && supportConfigs.EmailSupportSchedule.TimeZone,
          AskCommunity: supportConfigs.CommunityUrl,
        },
        Market: config.get('Culture'),
        EndPoint: config.get('HelpModel') && config.get('HelpModel').BaseHelpUrl,
        Success: null,
        SupportMarket: 'en-US',
        InitAnswerBar: false,
        InitPopup: true,
        InitOnReady: false,
      });
    }
  });
};

const runAnswerBarLoaderOnTimer = function () {
  // // Load answer Bar two seconds after page load is complete. This will enable all event binding complete before this blocking call is made.
  setTimeout(() => {
    try {
      answerBarLoader();
    } catch (e) { } // // non mandatory call, if something goes wrong host should not be affected.
  }, 2000);
};

if (compactFrameworkScriptUrl) {
  $(window).load(() => {
    runAnswerBarLoaderOnTimer();
  });
}
